import { generateTestId } from "@client-shared/lib/util";

export const setAuthLogoutTestId = (label: string) => generateTestId("AuthLogout", label.replace(/\s/g, "-").toLowerCase());
